import { combineReducers } from "redux-immutable";

import { newReducer } from "./new";
import { editReducer } from "./edit";

export default combineReducers({
	new: newReducer,
	edit: editReducer
});
